/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Partner_Profile_SectionInputs */

const en_users_partner_profile_section = /** @type {(inputs: Users_Partner_Profile_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partner Profile`)
};

const pt_br2_users_partner_profile_section = /** @type {(inputs: Users_Partner_Profile_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfil do Parceiro`)
};

/**
* | output |
* | --- |
* | "Partner Profile" |
*
* @param {Users_Partner_Profile_SectionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_partner_profile_section = /** @type {((inputs?: Users_Partner_Profile_SectionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Partner_Profile_SectionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_partner_profile_section(inputs)
	return pt_br2_users_partner_profile_section(inputs)
});